export default __webpack_public_path__ + "static/media/luxResidence.6743586e.svg";